import { Typography, Card, Row, Col, Empty } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export function DashboardPage() {
  return (
    <div>
      <Title level={3} style={{ marginBottom: 24 }}>Dashboard</Title>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card>
            <Empty
              image={<AppstoreOutlined style={{ fontSize: 48, color: '#d9d9d9' }} />}
              description={
                <div>
                  <Text type="secondary" style={{ fontSize: 16 }}>
                    No modules loaded yet
                  </Text>
                  <br />
                  <Text type="secondary">
                    Dashboard widgets will appear here as modules are installed.
                  </Text>
                </div>
              }
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
